import type { IExtractParams } from "@/routes";
import { setPassword } from "@api/auth/passwordReset/setPassword/path";
import { verify } from "@api/auth/passwordReset/verify/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/auth/password-resets/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const passwordReset = {
  post: apiPathFunc(pathBase),
  setPassword,
  verify,
};
